import styled from "styled-components";
import { t } from "i18next";
import { Group, SeededTeam } from "../types/Tournament";
import { I18nString } from "../types/I18nString";
import { Text } from "./styles";

type Props = {
  group: Group;
  showWinner: boolean;
  locale: keyof I18nString;
  ownTeamIds: Set<string>;
};

const teamName = (team: SeededTeam | undefined, locale: keyof I18nString): string => {
  if (!team) return t("OPEN");
  const division = team.divisionName?.[locale] || team.divisionName?.default || "";
  return division ? `${team.name} (${division})` : team.name;
};

const GroupCard = ({ group, showWinner, locale, ownTeamIds }: Props) => {
  return (
    <Card>
      {group.slots.map((slot, index) => {
        const { team, score, rank } = slot;
        const isWinner = showWinner && group.winner === index;
        const isLoser = showWinner && group.winner != null && group.winner !== index;
        const isOwn = !!team && ownTeamIds.has(team.id);
        return (
          <Row key={index} winner={isWinner} loser={!!isLoser} own={isOwn}>
            <SeedBox>
              <Text fontSize={12} fontColor={"#888888"} fontWeight={"bold"}>
                {team ? rank ?? team.seed : ""}
              </Text>
            </SeedBox>
            <NameBox>
              <Text
                fontSize={14}
                fontColor={"#000000"}
                fontWeight={isWinner || isOwn ? "bold" : "normal"}
                textAlign={"left"}
              >
                {teamName(team, locale)}
              </Text>
            </NameBox>
            <ScoreBox>
              <Text
                fontSize={14}
                fontColor={"#000000"}
                fontWeight={isWinner || isOwn ? "bold" : "normal"}
                textAlign={"right"}
              >
                {Number(score).toFixed(0)}
              </Text>
            </ScoreBox>
            <TrophyBox>
              <Text fontSize={14}>{isWinner ? "🏆" : ""}</Text>
            </TrophyBox>
          </Row>
        );
      })}
    </Card>
  );
};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 6px 0;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  overflow: hidden;
`;

const Row = styled.div<{ winner?: boolean; loser?: boolean; own?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 10px;
  padding-left: ${(props) => (props.own ? "6px" : "10px")};
  border-left: ${(props) => (props.own ? "4px solid #1565c0" : "none")};
  background-color: ${(props) =>
    props.winner ? "#e8f5e9" : props.own ? "#e7f0fb" : "#ffffff"};
  opacity: ${(props) => (props.loser ? 0.5 : 1)};
  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const SeedBox = styled.div`
  width: 28px;
  text-align: center;
`;

const NameBox = styled.div`
  flex: 1;
  text-align: left;
  padding: 0 8px;
  overflow: hidden;
`;

const ScoreBox = styled.div`
  min-width: 40px;
  text-align: right;
`;

const TrophyBox = styled.div`
  width: 24px;
  text-align: right;
`;

export default GroupCard;
